import React, { createContext, useContext } from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import Loader from './components/Loader';
const cookies = new Cookies()

/** True only while the logged-in role request is still in flight. */
export const RolePendingContext = createContext(false);

const PrivateRoute = ({ children, hasAccess, pending }: any) => {
    const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
    const authToken = cookies.get('skyToken')
    const rolePending = useContext(RolePendingContext);
    const needsLogin = !isAuthenticated?.isLogin || !authToken;
    const waiting = pending ?? rolePending;

    if (needsLogin) {
        return <Navigate to="/login" replace />
    }
    if (waiting) {
        return <Loader />;
    }
    if (hasAccess === 0) {
        return <Navigate to="/404" replace />
    }
    return children;
}

export default PrivateRoute
